module.exports = __webpack_public_path__ + "static/media/S45.06f7afed.png";